<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <div
          class="c-header -contain u-bg-gray-5"
          :style="{
            'background-image':
              'url(' +
              require('@arag/assets/img/content/nach_der_geburt_mf.svg') +
              ')',
          }"></div>
        <p class="ion-padding-top">
          <b
            >Nach der Geburt: In sieben Schritten durch den Behördendschungel
          </b>
        </p>
        <p>
          Herzlichen Glückwunsch zum Nachwuchs! Damit Ihr Weg durch die Ämter
          entspannt verläuft, finden Sie hier eine Step-by-Step-Anleitung für
          frischgebackene Eltern – von der Geburtsurkunde bis zum
          Kinderfreibetrag.
        </p>
        <p class="ion-padding-bottom">
          Kaum hat ein Baby das Licht der Welt erblickt, sehen seine Eltern
          oftmals kein Land mehr. Der Grund dafür: Die Formalitäten nach der
          Geburt. Keine Sorge: Wir lassen Sie nicht allein! Folgen Sie einfach
          den sieben Schritten, die wir für Sie zusammengestellt haben.
        </p>
        <!-- <div
                    class="ion-padding u-bg-gray-5 u-rounded u-small ion-text-center u-img-max-height-100"
                >
                    <ion-row class="ion-align-items-center">
                        <ion-col>
                            <img
                                src="@/assets/img/content/roodiecheck_schmerzen.svg"
                            />
                        </ion-col>
                        <ion-col>
                            <img
                                src="@/assets/img/content/roodiecheck_mentale_gesundheit.svg"
                            />
                        </ion-col>
                        <ion-col>
                            <img
                                src="@/assets/img/content/roodiecheck_schwere_zahnbehandlung.svg"
                            />
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <div>Körperliche Beschwerden</div>
                        </ion-col>
                        <ion-col>
                            <div>Mentale Gesundheit</div>
                        </ion-col>
                        <ion-col>
                            <div>Schwere Zahnbehandlung</div>
                        </ion-col>
                    </ion-row>
                </div> -->
        <!-- <div class="c-line"></div> -->
        <ion-row class="ion-margin-top">
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/geburtsurkunde')">
              <div
                class="c-nugget__image u-bg-green"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Geburtsurkunde.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Geburts&shy;urkunde</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/einwohnermeldeamt')">
              <div
                class="c-nugget__image u-bg-blue"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Einwohnermeldeamt.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Einwohner&shy;meldeamt</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/krankenversicherung')">
              <div
                class="c-nugget__image u-bg-red"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Krankenversicherung.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Kranken&shy;versicherung</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/kindergeld')">
              <div
                class="c-nugget__image u-bg-yellow"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Kindergeld.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Kinder&shy;geld</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/elterngeld')">
              <div
                class="c-nugget__image u-bg-orange"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Elterngeld.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Eltern&shy;geld</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/vaterschaft')">
              <div
                class="c-nugget__image u-bg-purple"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Anerkennung_der_Vaterschaft.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Anerkennung der Vaterschaft</div>
            </div>
          </ion-col>
          <ion-col size="6" size-lg="4">
            <div
              class="c-nugget"
              @click="$router.push('/nachdergeburt/kinderfreibetrag')">
              <div
                class="c-nugget__image u-bg-gray-5"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_Kinderfreibetrag.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Kinder&shy;freibetrag</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonBackButton,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    IonBackButton,
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped>
.c-nugget {
  margin-top: 16px;
}
</style>
